var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9905 0.102417C6.20558 0.102417 0.68335 5.62465 0.68335 12.4095C0.68335 19.1944 6.20558 24.7166 12.9905 24.7166C19.7753 24.7166 25.2976 19.1944 25.2976 12.4095C25.2976 5.62465 19.7753 0.102417 12.9905 0.102417ZM12.9905 2.1536C18.6668 2.1536 23.2464 6.73319 23.2464 12.4095C23.2464 17.5656 19.4637 21.8053 14.5168 22.5413V15.4002H17.4374L17.8961 12.4336H14.5168V10.8131C14.5168 9.58131 14.9215 8.48744 16.0732 8.48744H17.9241V5.89942C17.599 5.85532 16.911 5.7592 15.6105 5.7592C12.8948 5.7592 11.3038 7.19296 11.3038 10.4605V12.4336H8.51151V15.4002H11.3038V22.5152C6.43575 21.7123 2.73453 17.5098 2.73453 12.4095C2.73453 6.73319 7.31412 2.1536 12.9905 2.1536Z",
    fill: "#445A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSvg);
export default __webpack_public_path__ + "static/media/facebook_svg.be3e9ad2118c282fc450e243ea381926.svg";
export { ForwardRef as ReactComponent };